import {find} from 'lodash'
import ClientApi from '@/api/Clients/api'

export default {
  computed: {
    clientsListProjects: {
      get () {
        return this.$store.getters.clientsListProjects
      },
      set (data) {
        this.$store.dispatch('setClientsListProjects', data)
      }
    }
  },
  methods: {
    async getClient (id) {
      if (!id) return ''
      if (typeof id === 'object') return id
      const client = find(this.clientsListProjects, {id: id})
      if (client) return client
      try {
        const resp = await ClientApi.getClient(id)
        return resp.data
      } catch (e) {
        console.error(e)
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getClient.js